module.exports = __webpack_public_path__ + "static/media/dine_in.a099ae9f.png";